import recipeApiSchema from "../../plans/recipe-api-schema.json";

const tagRules = [
  "- Include a tags array on every recipe. Each tag is { path: string[] } with one or more segments (e.g. [\"Desserts\", \"Cakes\"]).",
  "- Infer sensible hierarchical tags from the recipe (course, diet, cuisine, etc.).",
  "- When assigning a child tag, also include ancestor paths (e.g. [\"Desserts\"] and [\"Desserts\", \"Cakes\"])."
];

function sharedOutputRules(singleObject: boolean): string[] {
  return [
    "Output rules (strict):",
    singleObject
      ? "- Return ONLY the JSON object. No markdown code fences, no explanation, no preamble or postscript."
      : "- Return ONLY a JSON array of RecipeInput objects. No markdown code fences, no explanation, no preamble or postscript.",
    "- Use stable string ids on every ingredient and step.",
    "- Step summaries must be short and verb-led; put longer text in details.",
    "- Use kind \"prep\" or \"cook\" where appropriate; attach timers when durations are given.",
    ...tagRules
  ];
}

export function parseUrlList(text: string): string[] {
  return text
    .split(/[\s,]+/u)
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
}

export function buildExternalAiRecipePrompt(recipeUrl: string): string {
  const url = recipeUrl.trim() || "<recipe URL>";
  const schemaJson = JSON.stringify(recipeApiSchema, null, 2);

  return [
    "You are a recipe extraction agent for the Cairn app.",
    "",
    `1. Fetch the recipe page at this URL: ${url}`,
    "2. Read the full recipe (title, servings, ingredients, equipment, and steps).",
    "3. Convert it into a single JSON object that validates as RecipeInput in the schema below.",
    "",
    ...sharedOutputRules(true),
    "",
    "JSON Schema (RecipeInput):",
    schemaJson
  ].join("\n");
}

export function buildExternalAiBulkRecipePrompt(urls: readonly string[]): string {
  const cleaned = urls.map((url) => url.trim()).filter((url) => url.length > 0);
  const urlList = cleaned.length > 0 ? cleaned.join("\n") : "<recipe URLs, one per line>";
  const schemaJson = JSON.stringify(recipeApiSchema, null, 2);

  return [
    "You are a recipe extraction agent for the Cairn app.",
    "",
    "1. Fetch each recipe page at these URLs (one per line):",
    urlList,
    "2. Read each full recipe (title, servings, ingredients, equipment, and steps).",
    "3. Convert each into a RecipeInput object that validates against the schema below.",
    "4. Return a single JSON array containing every parsed recipe, in the same order as the URLs.",
    "",
    ...sharedOutputRules(false),
    "",
    "JSON Schema (RecipeInput):",
    schemaJson
  ].join("\n");
}
